<app-network-detector (onOnline)="setOnline()" (onOffline)="setOffline()"></app-network-detector>

<div class="spd" [attr.data-state]="state">

  <div class="spd__header">
    <h1 class="spd__title">{{ title }}</h1>
    <!-- No X while "อนุมัติแล้ว" is up, nor while POST /bypass or POST /staff-menu is in flight:
         closing then would record the PIN use and never unlock the photobooth. -->
    <button type="button" class="spd__close" aria-label="ปิด" *ngIf="state !== State.APPROVED && !granting"
      (click)="closeDialog()">&times;</button>
  </div>

  <div class="spd__body" [ngSwitch]="state">

    <!-- 1. Keypad: checked once, at the 6th digit -->
    <ng-container *ngSwitchCase="State.PIN">
      <p class="spd__hint">{{ busy ? TXT.CHECKING : TXT.ENTER_PIN }}</p>
      <div class="spd__dots" aria-hidden="true">
        <span class="spd__dot" *ngFor="let i of dots" [class.spd__dot--on]="i < typed.length"></span>
      </div>
      <p class="spd__message" *ngIf="message" [class.spd__message--good]="message === TXT.LOCKOUT_LIFTED">{{ message }}</p>
      <div class="spd__keypad">
        <button type="button" class="spd__key" *ngFor="let key of digitKeys" [disabled]="busy"
          (click)="addDigit(key)">{{ key }}</button>
        <button type="button" class="spd__key spd__key--fn" [disabled]="busy" (click)="clearPin()">{{ TXT.KEY_CLEAR }}</button>
        <button type="button" class="spd__key" [disabled]="busy" (click)="addDigit('0')">0</button>
        <button type="button" class="spd__key spd__key--fn" [disabled]="busy" (click)="deleteDigit()">{{ TXT.KEY_DELETE }}</button>
      </div>
    </ng-container>

    <!-- 2 + 3. Greeting, today's count, reason buttons (payment bypass) -->
    <ng-container *ngSwitchCase="State.REASONS">
      <h2 class="spd__greeting">{{ TXT.GREETING }}{{ check?.staff?.nickname }}</h2>
      <p class="spd__count" *ngIf="countText">{{ countText }}</p>
      <p class="spd__warn" *ngIf="needsApproval">{{ TXT.OVER_LIMIT }}</p>
      <p class="spd__message" *ngIf="message">{{ message }}</p>
      <p class="spd__hint">{{ TXT.CHOOSE_REASON }}</p>

      <div class="spd__reasons" *ngIf="reasons.length > 0">
        <button type="button" class="spd__reason" *ngFor="let reason of reasons" [disabled]="busy"
          [class.spd__reason--approval]="needsApproval" [class.spd__reason--active]="activeReasonId === reason.id"
          (click)="chooseReason(reason)">
          <span class="spd__reason-label">{{ reason.label_th }}</span>
          <span class="spd__reason-action" *ngIf="needsApproval">{{ TXT.SEND_FOR_APPROVAL }}</span>
        </button>
      </div>
      <p class="spd__hint" *ngIf="reasonsLoading && reasons.length === 0">{{ TXT.CHECKING }}</p>
      <div class="spd__center" *ngIf="reasonsFailed && !reasonsLoading && reasons.length === 0">
        <p class="spd__message">{{ TXT.REASONS_FAILED }}</p>
        <button type="button" class="spd__action" (click)="loadReasons()">{{ TXT.TRY_AGAIN }}</button>
      </div>
    </ng-container>

    <!-- 4. Waiting for the approver: countdown and Cancel only (D35) -->
    <ng-container *ngSwitchCase="State.PENDING">
      <div class="spd__center">
        <h2 class="spd__greeting">{{ TXT.WAITING }}</h2>
        <p class="spd__count" *ngIf="request">{{ request.reason_label_th }}</p>
        <div class="spd__countdown">{{ countdownText }}</div>
        <p class="spd__message" *ngIf="isOffline">{{ TXT.OFFLINE }}</p>
        <button type="button" class="spd__action" (click)="cancelRequest()">{{ TXT.CANCEL }}</button>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="State.APPROVED">
      <div class="spd__center">
        <div class="spd__big-icon" aria-hidden="true">&#10003;</div>
        <h2 class="spd__greeting">{{ TXT.APPROVED }}</h2>
        <p class="spd__hint" *ngIf="request?.decided_by_name">{{ TXT.APPROVED_BY }}{{ request?.decided_by_name }}</p>
        <p class="spd__note-label" *ngIf="request?.note_label_th">{{ request?.note_label_th }}</p>
        <p class="spd__note-text" *ngIf="request?.note_text">{{ request?.note_text }}</p>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="State.SUCCESS">
      <div class="spd__center">
        <div class="spd__big-icon" aria-hidden="true">&#10003;</div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="State.REJECTED">
      <div class="spd__center">
        <h2 class="spd__greeting spd__greeting--bad">{{ TXT.REJECTED }}</h2>
        <p class="spd__note-label" *ngIf="request?.note_label_th">{{ request?.note_label_th }}</p>
        <p class="spd__note-text" *ngIf="request?.note_text">{{ request?.note_text }}</p>
        <p class="spd__hint" *ngIf="request?.decided_by_name">{{ request?.decided_by_name }}</p>
        <button type="button" class="spd__action" (click)="resetToPin()">{{ TXT.BACK }}</button>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="State.EXPIRED">
      <div class="spd__center">
        <h2 class="spd__greeting spd__greeting--bad">{{ TXT.EXPIRED }}</h2>
        <button type="button" class="spd__action" (click)="resetToPin()">{{ TXT.BACK }}</button>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="State.CANCELLED">
      <div class="spd__center">
        <h2 class="spd__greeting">{{ TXT.CANCELLED }}</h2>
        <button type="button" class="spd__action" (click)="resetToPin()">{{ TXT.BACK }}</button>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="State.NO_APPROVER">
      <div class="spd__center">
        <h2 class="spd__greeting spd__greeting--bad">{{ TXT.NO_APPROVER }}</h2>
        <button type="button" class="spd__action" (click)="resetToPin()">{{ TXT.BACK }}</button>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="State.LOCKED">
      <div class="spd__center">
        <h2 class="spd__greeting spd__greeting--bad">{{ TXT.LOCKED }}</h2>
        <p class="spd__hint">{{ TXT.LOCKED_DETAIL }}</p>
        <div class="spd__countdown">{{ countdownText }}</div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="State.OFFLINE">
      <div class="spd__center">
        <h2 class="spd__greeting spd__greeting--bad">{{ TXT.OFFLINE }}</h2>
        <p class="spd__hint" *ngIf="isBypass">{{ TXT.OFFLINE_DETAIL }}</p>
        <button type="button" class="spd__action" (click)="resetToPin()">{{ TXT.TRY_AGAIN }}</button>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="State.ERROR">
      <div class="spd__center">
        <h2 class="spd__greeting spd__greeting--bad">{{ TXT.ERROR }}</h2>
        <button type="button" class="spd__action" (click)="resetToPin()">{{ TXT.TRY_AGAIN }}</button>
      </div>
    </ng-container>

  </div>
</div>
